<template>
  <nav v-if="items.length" class="sh-global-bottom-nav" aria-label="Mobile module navigation">
    <button
      v-for="item in items"
      :key="item.to"
      type="button"
      class="sh-gbn-item"
      :class="{ 'is-active': isActive(item) }"
      @click="go(item.to)"
    >
      <span class="sh-gbn-icon" v-html="item.icon"></span>
      <span class="sh-gbn-label">{{ item.label }}</span>
    </button>
  </nav>
</template>

<script>
const icons = {
  dashboard: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>',
  students: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
  teachers: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  staff: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>',
  class: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z"/></svg>',
  receipt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z"/><path d="M8 7h8M8 11h8M8 15h5"/></svg>',
  balance: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M7 16l4-4 3 3 5-7"/></svg>',
  reports: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8M8 17h5"/></svg>',
  route: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="6" cy="19" r="3"/><circle cx="18" cy="5" r="3"/><path d="M6 16V9a4 4 0 0 1 4-4h5"/></svg>',
  bus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="3" width="16" height="14" rx="2"/><path d="M6 17v2M18 17v2M4 9h16M8 13h.01M16 13h.01"/></svg>',
  map: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l-6 3V6l6-3 6 3 6-3v15l-6 3-6-3z"/><path d="M9 3v15M15 6v15"/></svg>',
  exam: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>',
  subject: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>',
  timetable: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',
  payroll: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/><path d="M7 15h.01M11 15h2"/></svg>',
  users: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>',
  settings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.33 1.82V22a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 8 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1.82-.33H2a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 8a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-.6 1.65 1.65 0 0 0 .33-1.82V2a2 2 0 1 1 4 0v.09A1.65 1.65 0 0 0 16 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.22.37.6.66 1 .78.32.1.66.06.95-.09H22a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.82.33 1.65 1.65 0 0 0-.69.98z"/></svg>'
};

const moduleNavs = {
  registration: [
    { label: 'Dashboard', to: '/registration', icon: icons.dashboard },
    { label: 'Students', to: '/students', icon: icons.students },
    { label: 'Teachers', to: '/teachers', icon: icons.teachers },
    { label: 'Staff', to: '/staff', icon: icons.staff }
  ],
  finance: [
    { label: 'Dashboard', to: '/finance', icon: icons.dashboard },
    { label: 'Receipts', to: '/feepayments', icon: icons.receipt },
    { label: 'Balances', to: '/feebalances', icon: icons.balance },
    { label: 'Reports', to: '/FinancialReports', icon: icons.reports }
  ],
  transport: [
    { label: 'Dashboard', to: '/transport', icon: icons.dashboard },
    { label: 'Routes', to: '/transport/routes', icon: icons.route },
    { label: 'Assign', to: '/transport/assignments', icon: icons.bus },
    { label: 'Reports', to: '/transport/reports', icon: icons.reports }
  ],
  academics: [
    { label: 'Dashboard', to: '/dashboard', icon: icons.dashboard },
    { label: 'Exams', to: '/exams', icon: icons.exam },
    { label: 'Subjects', to: '/subjects', icon: icons.subject },
    { label: 'Grades', to: '/grades', icon: icons.reports }
  ],
  timetable: [
    { label: 'Dashboard', to: '/timetable', icon: icons.dashboard },
    { label: 'List', to: '/timetable/list', icon: icons.timetable },
    { label: 'Classes', to: '/timetable/classes', icon: icons.class },
    { label: 'Teachers', to: '/timetable/teachers', icon: icons.teachers }
  ],
  hr: [
    { label: 'Dashboard', to: '/hr', icon: icons.dashboard },
    { label: 'Employees', to: '/hr/employees', icon: icons.users },
    { label: 'Payroll', to: '/hr/payroll', icon: icons.payroll },
    { label: 'Leave', to: '/hr/leave', icon: icons.reports }
  ],
  superadmin: [
    { label: 'Schools', to: '/superadmin', icon: icons.dashboard },
    { label: 'Users', to: '/superUsers', icon: icons.users },
    { label: 'Branches', to: '/branches', icon: icons.route },
    { label: 'Home', to: '/home', icon: icons.dashboard }
  ]
};

const registrationNames = new Set(['Registration', 'RegStudents', 'Transfers', 'RegistrationClasses', 'RegTeachers', 'RegStaff', 'Board', 'leaveouts']);
const financeNames = new Set(['Finance', 'FinanceOtp', 'FinStudents', 'Budgets', 'BankReconciliation', 'Refunds', 'FeeStructures', 'StudentCollections', 'TermSetup', 'YearEndClose', 'AccountGroups', 'FinanceSettings', 'FinanceStamp', 'ManualJournal', 'billbyexcel', 'Supliers', 'GroupReceipts', 'Pvs', 'FinancialReports', 'AuditTrail', 'studentbilling', 'OtherIncomes', 'BankAccounts', 'ChartofAccounts', 'BalanceNotifications', 'BalanceNotificationsSend', 'ReceiptNotifications', 'InvoiceNotifications', 'InvoiceNotificationsSend', 'MessageTemplates', 'FeeReminders', 'Receipts', 'UnreconciledPayments', 'Balances', 'pocketmoney']);
const superAdminNames = new Set(['AdminDashboard', 'SuperUsers', 'Branches', 'BranchSchools', 'BranchUsers']);
const publicNames = new Set(['/', 'Reset', 'ResetWithOtp', 'LoginOtp']);
const academicNames = new Set(['ExamDash', 'Exams', 'MySubjects', 'MarksSheet', 'MarksSheetAdmin', 'ExamAnalysis', 'TermlyConduct', 'MyExams', 'Grades', 'Subjects', 'SubjectGroups', 'ExamCategories', 'Remarks', 'GradingSystem', 'RequiredSubs', 'ReportDates', 'ReportColours', 'AcademicsSettings', 'ExamResultsSend', 'SchoolStamp']);

export default {
  name: 'MobileBottomNav',
  computed: {
    moduleKey() {
      const path = String(this.$route.path || '').toLowerCase();
      const name = this.$route.name;

      if (path === '/' || path.startsWith('/reset') || publicNames.has(name)) return null;

      if (path.startsWith('/transport')) return 'transport';
      if (path.startsWith('/timetable')) return 'timetable';
      if (path.startsWith('/hr') || String(name || '').startsWith('hr')) return 'hr';
      if (path.startsWith('/superadmin') || superAdminNames.has(name)) return 'superadmin';
      if (registrationNames.has(name)) return 'registration';
      if (financeNames.has(name)) return 'finance';
      if (academicNames.has(name)) return 'academics';
      return null;
    },
    items() {
      return moduleNavs[this.moduleKey] || [];
    }
  },
  methods: {
    go(to) {
      if (this.$route.path === to) return;
      this.$router.push(to).catch(() => {});
    },
    isActive(item) {
      const path = this.$route.path || '';
      if (item.to === '/transport') return path === '/transport';
      if (item.to === '/finance') return path === '/finance';
      if (item.to === '/registration') return path === '/registration';
      if (item.to === '/timetable') return path === '/timetable';
      if (item.to === '/hr') return path === '/hr';
      return path === item.to || path.startsWith(`${item.to}/`);
    }
  }
};
</script>

<style>
@media (max-width: 991.98px) {
  :root { --sh-global-bottom-nav-height: 68px; }

  /* Hide older per-page bottom navs so every module gets one consistent app-like bar. */
  .bottom-nav:not(.sh-global-bottom-nav) { display: none !important; }

  body {
    padding-bottom: calc(var(--sh-global-bottom-nav-height) + env(safe-area-inset-bottom, 0px)) !important;
  }

  #mainpaage,
  main#sidenavmain,
  #sidenavmain.main-content,
  .main-content {
    padding-bottom: calc(var(--sh-global-bottom-nav-height) + env(safe-area-inset-bottom, 0px) + 14px) !important;
  }

  .sh-global-bottom-nav {
    position: fixed;
    left: 10px;
    right: 10px;
    bottom: calc(8px + env(safe-area-inset-bottom, 0px));
    min-height: 58px;
    padding: 6px;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 4px;
    background: rgba(255, 255, 255, .92);
    border: 1px solid rgba(148, 163, 184, .35);
    border-radius: 20px;
    box-shadow: 0 16px 48px rgba(15, 23, 42, .20);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
    z-index: 48000;
  }

  .sh-gbn-item {
    appearance: none;
    border: 0;
    background: transparent;
    color: #64748b;
    border-radius: 16px;
    min-width: 0;
    min-height: 48px;
    padding: 6px 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    font-size: 10px;
    font-weight: 800;
    line-height: 1;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .sh-gbn-icon,
  .sh-gbn-icon svg {
    width: 21px;
    height: 21px;
    display: block;
  }

  .sh-gbn-label {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .sh-gbn-item.is-active {
    color: var(--theme-primary, #e91e63);
    background: rgba(233, 30, 99, .11);
  }

  body.dark-version .sh-global-bottom-nav,
  [data-theme="dark"] .sh-global-bottom-nav {
    background: rgba(15, 23, 42, .94);
    border-color: rgba(148, 163, 184, .26);
    box-shadow: 0 18px 52px rgba(0, 0, 0, .45);
  }

  body.dark-version .sh-gbn-item,
  [data-theme="dark"] .sh-gbn-item {
    color: #94a3b8;
  }

  body.dark-version .sh-gbn-item.is-active,
  [data-theme="dark"] .sh-gbn-item.is-active {
    color: #f9a8d4;
    background: rgba(233, 30, 99, .17);
  }
}

@media (min-width: 992px) {
  .sh-global-bottom-nav { display: none !important; }
}

@media print {
  .sh-global-bottom-nav { display: none !important; }
}
</style>
